import React from 'react';
import NumberElement from './Number';
import WrapComponent from '../WrapComponent';

class  Currency extends React.PureComponent{
    render(){
        let {length, currency_unit, decimal_places} = this.props;
        let appendProps = {
            length: length || 12,
            decimal_places: decimal_places || 2,
            captialize: true,
            type: 'money',
            extra: currency_unit
        }
        return (
            <div className="form-percentile">
                <NumberElement {...this.props} {...appendProps}/>
            </div>
        )
    }
}
export default WrapComponent(Currency);


// WEBPACK FOOTER //
// ./src/component/Number/Currency.js